import { useLang } from '@/i18n';
import EcoEmail from 'eco-design/elements/eco-email';
import EcoSpace from 'eco-design/base/eco-space';
import EFPicture from '@elem/compCommon/EFPicture';
import EcoButton from 'eco-design/base/eco-button';
import { subscribeCookie } from 'eco-design-reliance/cookies/subscribeCookie';

import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import moment from 'moment';

export default function Comp() {
    const { t } = useLang('theProduct.SectionA5');

    const SUB_SOURCE = 'WEB_NEW_PRODUCT_SUB';

    const contactListId = ['396526985'];
    const { getSystemTime } = useGlobal();
    const systemTime = getSystemTime();
    const date = moment(systemTime).format('YYYY-MM-DD') as any;

    const fields = [
        // 站点字段
        {
            id: '4431',
            type: 'single',
            value: 1,
            overwrite: true,
        },
        // Opt-In
        {
            id: '31',
            type: 'single',
            value: 1,
            overwrite: false,
        },
        // 产品字段
        {
            id: '9422',
            type: 'multiple',
            value: ['21'],
            overwrite: false,
        },
        {
            id: '9627',
            type: 'text',
            value: date,
            overwrite: false,
        },
    ];

    return (
        <div className="eco-content">
            <EcoSpace />
            <div className={styles.comp}>
                <div className="comp-box-l">
                    <div className="comp-l-title">{t('titleL')}</div>
                    <div className="comp-l-desc">{t('descL')}</div>
                    <EcoEmail
                        contactListId={contactListId}
                        defaultTermsCheck={true}
                        fields={fields}
                        source={SUB_SOURCE}
                        subscribeData={subscribeCookie({
                            sector_name: t('titleL'),
                            entry_position: 10,
                        })}
                    />
                </div>
                <div className="comp-box-line" />
                <div className="comp-box-r">
                    <div className="comp-r-title">{t('titleR')}</div>
                    <div className="comp-r-desc">{t('descR')}</div>
                    <div className="comp-r-action">
                        <div className="comp-r-img">
                            <EFPicture
                                src="https://websiteoss.ecoflow.com/upload/image/1741919790537/subscibe_qr.png"
                                srcPad="https://websiteoss.ecoflow.com/upload/image/1741919790537/subscibe_qr.png"
                                srcMobile="https://websiteoss.ecoflow.com/upload/image/1741919790537/subscibe_qr.png"
                            />
                        </div>
                        <EcoButton
                            lHref="https://lin.ee/kEyXABx"
                            lChildren={t('button_text')}
                            lBgColor="#06C755"
                            lDataLayer={{
                                event: 'uaEvent',
                                event_name: 'line_icon_click',
                                button_name: t('button_text'),
                                url: 'https://lin.ee/kEyXABx',
                            }}
                            subscribeData={{
                                sector_name: t('titleL'),
                                entry_position: 10,
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
